import { EnumObjectValue } from '@shared/utils/common/types';

export type BrowserTypeValue = EnumObjectValue<typeof BrowserType>;
export const BrowserType = {
  CHROME: 'Chrome',
  FIREFOX: 'Firefox',
  SAFARI: 'Safari',
  EDGE: 'Edge',
  EXPLORER: 'Explorer',
  OPERA: 'Opera',
  OTHER: 'Other'
} as const;
